var _linearGradient, _path, _g, _path2, _circle, _path3, _path4, _path5, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _circle2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportFaqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 119.196 84",
    width: 119.196,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_faq_icon_svg__a",
    gradientUnits: "objectBoundingBox",
    x1: 0.232,
    x2: 0.843,
    y1: 1,
    y2: 0.043
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.8 67.735a6.491 6.491 0 1 1 6.492 6.492 6.491 6.491 0 0 1 -6.492-6.492zm1.331-18.093c-.059-3.734-.09-8.333-.09-8.86a13.218 13.218 0 0 1 .547-3.777c2.067-5.985 8.844-10.348 8.844-10.348a9.032 9.032 0 1 0 -13.9-7.6v1.018a4.763 4.763 0 1 1 -9.532-.001c0-.861 0-1.52 0-1.614a18.733 18.733 0 0 1 37.463.273 12.249 12.249 0 0 1 -.352 2.658 19.592 19.592 0 0 1 -6.736 10.724c-2.913 2.388-6.459 6.051-6.459 9.725 0 .289.012 4.27.032 7.69a4.91 4.91 0 0 1 -9.819.111z",
    fill: "url(#support_faq_icon_svg__a)",
    transform: "translate(41.583 9.596)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m383.522 276.1c3.632-1.091 7.492-2.228 10.372-4.821 2.574-2.317 4.311-5.855 3.245-9.329s-4.251-5.78-7.541-6.929a30.941 30.941 0 0 0 -5.77-1.3c-2.122-.309-4.253-.562-6.383-.806q-12.937-1.48-25.971-1.808c-4.288-.108-8.575-.105-12.863-.043-3.83.056-7.863.054-11.416-1.573a10.525 10.525 0 0 1 -6.04-6.595c-.889-3.493.75-7.051 3.1-9.581a25.115 25.115 0 0 1 4.182-3.488c1.621-1.12 3.3-2.16 5.012-3.131a69.807 69.807 0 0 1 10.551-4.857c1.8-.654 3.624-1.218 5.465-1.739a46.769 46.769 0 0 0 4.617-1.479c2.9-1.158 5.667-3.119 6.406-6.333a9.9 9.9 0 0 0 -2.549-8.618c-2.394-2.619-6-3.767-9.463-3.952a30.477 30.477 0 0 0 -11.331 2c-3.894 1.316-7.7 2.829-11.681 3.9a78.593 78.593 0 0 1 -12.022 2.235 32.614 32.614 0 0 1 -6.034.289 7.3 7.3 0 0 1 -4.577-1.818 4.526 4.526 0 0 1 -1.473-3.9c.039-.269.447-.154.408.113a4.465 4.465 0 0 0 2.467 4.308 10.535 10.535 0 0 0 5.8.871 75.9 75.9 0 0 0 12.491-1.806 100.384 100.384 0 0 0 11.812-3.646 43.14 43.14 0 0 1 11.408-2.931 17.036 17.036 0 0 1 10 2.035 11.064 11.064 0 0 1 5.16 7.2 8.345 8.345 0 0 1 -2.455 7.947c-2.3 2.123-5.461 3.031-8.4 3.867a77 77 0 0 0 -10.921 3.909 68.56 68.56 0 0 0 -10.273 5.776c-3.139 2.145-6.237 4.845-7.23 8.672a7.988 7.988 0 0 0 .4 5.357 9.79 9.79 0 0 0 3.141 3.728c3.15 2.318 7.12 2.794 10.924 2.841 4.273.053 8.546-.091 12.821-.021q13.067.214 26.081 1.591 3.261.345 6.513.763a58.889 58.889 0 0 1 5.825.945c3.41.791 6.727 2.313 8.847 5.2a8.229 8.229 0 0 1 .7 9c-1.627 3.2-4.676 5.239-7.913 6.577a56.143 56.143 0 0 1 -5.327 1.8.212.212 0 0 1 -.113-.408z",
    transform: "translate(-283.867 -192.648)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.766,
    cy: 9.808,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.261,
    cy: 16.228,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.158,
    cy: 3.387,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.576,
    cy: 17.781,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.784,
    cy: 34.432,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.475,
    cy: 42.476,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.054,
    cy: 55.035,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.325,
    cy: 62.091,
    r: 3.387
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.689,
    cy: 60.538,
    r: 3.387
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m296.691 745.586h-118.861a.168.168 0 0 1 0-.336h118.86a.168.168 0 1 1 0 .336z",
    fill: "#3f3d56",
    transform: "translate(-177.662 -661.586)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.683,
    cy: 34.29,
    fill: "#2f2e41",
    r: 4.233
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m557.473 541.514h-1.73l-.823-6.673h2.553z",
    fill: "#a0616a",
    transform: "translate(-476.613 -459.367)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m539.21 578.626h3.336v2.1h-5.437a2.1 2.1 0 0 1 2.101-2.1z",
    fill: "#2f2e41",
    transform: "translate(-461.315 -496.974)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m652.473 541.514h-1.73l-.823-6.673h2.553z",
    fill: "#a0616a",
    transform: "translate(-558.207 -459.367)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m634.21 578.626h3.336v2.1h-5.437a2.1 2.1 0 0 1 2.101-2.1z",
    fill: "#2f2e41",
    transform: "translate(-542.909 -496.974)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.04,
    cy: 35.083,
    fill: "#a0616a",
    rx: 3.466,
    ry: 3.466
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m740.768 444.576 1.551-3.563a4.429 4.429 0 0 0 -.981-5.024 4.5 4.5 0 0 0 -.433-.377 4.365 4.365 0 0 0 -2.68-.927 4.541 4.541 0 0 0 -1.891.421c-.051.023-.1.047-.151.071-.1.047-.193.1-.286.15a4.471 4.471 0 0 0 -2.216 3.37l-.681 5.733c-.172.45-6.313 16.707-4.166 29.118a.63.63 0 0 0 .539.518l2.177.3a.634.634 0 0 0 .707-.5l3.654-17.415a.494.494 0 0 1 .96-.032l5.162 18.314a.631.631 0 0 0 .608.463.716.716 0 0 0 .123-.011l2.66-.512a.631.631 0 0 0 .512-.679c-.394-4.362-2.472-26.194-5.168-29.418z",
    fill: "#2f2e41",
    transform: "translate(-650.662 -394.846)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m706.044 413.686a1.419 1.419 0 0 0 1.495 1.581l1.937 4.656 1.465-2.172-2.064-4.088a1.427 1.427 0 0 0 -2.833.024z",
    fill: "#a0616a",
    transform: "translate(-631.473 -375.719)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m790.419 503.242a1.419 1.419 0 0 0 1.189-1.822l4.076-2.969-2.454-.919-3.495 2.96a1.427 1.427 0 0 0 .683 2.75z",
    fill: "#a0616a",
    transform: "translate(-702.571 -448.825)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m722.611 445.336a2.4 2.4 0 0 1 -.465-.046 2.3 2.3 0 0 1 -1.686-1.357l-2.714-3.31a.635.635 0 0 1 .157-.943l1.931-1.2a.635.635 0 0 1 .877.21l1.913 3.152 3.664-2.707a1.372 1.372 0 0 1 1.6 2.2l-3.656 3.335a2.293 2.293 0 0 1 -1.621.666z",
    fill: "#2f2e41",
    transform: "translate(-641.408 -398.028)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m808.938 456.612h-.015a.636.636 0 0 1 -.467-.222l-1.717-2a.635.635 0 0 1 .13-.942l3.215-2.143-2.912-3.5a1.372 1.372 0 0 1 2.1-1.719l3.54 3.459a2.332 2.332 0 0 1 -.519 3.8l-2.893 3.07a.636.636 0 0 1 -.462.2z",
    fill: "#2f2e41",
    transform: "translate(-717.836 -404.327)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m783.638 437.6a.646.646 0 0 1 -.082-.005.629.629 0 0 1 -.524-.433l-1.29-3.955a.435.435 0 0 1 .225-.526l.042-.02.114-.053a4.6 4.6 0 0 1 1.92-.427 4.421 4.421 0 0 1 2.422.728.442.442 0 0 1 .127.606l-2.42 3.791a.629.629 0 0 1 -.534.294z",
    fill: "#e6e6e6",
    transform: "translate(-696.479 -392.699)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.021,
    cy: 31.015,
    fill: "#2f2e41",
    r: 1.385
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m773.78 361.365a3.669 3.669 0 0 0 -3.669 3.669v1.552h1.909l.913-1.552.274 1.552h5.793l-1.552-1.552a3.669 3.669 0 0 0 -3.668-3.669z",
    fill: "#2f2e41",
    transform: "translate(-686.508 -331.873)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m834.809 356.382a2.138 2.138 0 0 1 2.326-1.467 2.962 2.962 0 0 1 2 1.65 16.236 16.236 0 0 1 .888 2.53 4.582 4.582 0 0 0 1.382 2.256 2.057 2.057 0 0 0 2.482.134 2.839 2.839 0 0 1 -5.289 1.013 6.139 6.139 0 0 1 -.569-2.152 4.7 4.7 0 0 0 -.686-2.108 1.744 1.744 0 0 0 -1.948-.725z",
    fill: "#2f2e41",
    transform: "translate(-742.076 -326.316)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m478.038 290.149a4.762 4.762 0 0 1 -4.762-4.761c0-.862 0-1.52 0-1.614a18.557 18.557 0 0 1 2.167-8.454 18.6 18.6 0 0 0 -3.578 10.712v1.614a4.762 4.762 0 0 0 4.761 4.762 4.766 4.766 0 0 0 4.585-3.47 4.744 4.744 0 0 1 -3.173 1.211z",
    fill: "#3f3d56",
    transform: "translate(-430.349 -257.969)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m561.953 277.673a9.032 9.032 0 0 1 7.854 12.617 9.031 9.031 0 1 0 -15.159-9.453 9.013 9.013 0 0 1 7.305-3.164z",
    fill: "#3f3d56",
    transform: "translate(-501.45 -258.043)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m577.776 473.194a4.909 4.909 0 0 1 -4.909-4.83c-.06-3.732-.091-8.332-.091-8.858a13.266 13.266 0 0 1 .547-3.777 13.414 13.414 0 0 1 .775-1.792 15.53 15.53 0 0 0 -2.186 4.05 13.262 13.262 0 0 0 -.547 3.777c0 .526.031 5.125.091 8.859a4.909 4.909 0 0 0 4.909 4.829 4.911 4.911 0 0 0 4.713-3.534 4.891 4.891 0 0 1 -3.302 1.276z",
    fill: "#3f3d56",
    transform: "translate(-515.807 -411.381)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m126.538 541.969h1.73l.823-6.673h-2.553z",
    fill: "#ffb8b8",
    transform: "translate(-108.682 -459.758)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.437v2.1h-3.337a2.1 2.1 0 0 1 -2.1-2.1z",
    fill: "#2f2e41",
    transform: "matrix(-1 .00005236 -.00005236 -1 22.923 83.817)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m82.538 541.969h1.73l.823-6.673h-2.553z",
    fill: "#ffb8b8",
    transform: "translate(-70.891 -459.758)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.437v2.1h-3.337a2.1 2.1 0 0 1 -2.1-2.1z",
    fill: "#2f2e41",
    transform: "matrix(-1 .00005236 -.00005236 -1 16.714 83.817)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m256.829 579.5-1.69-.089a.66.66 0 0 1 -.624-.7l2.02-22.362 9.3 2.51.9-.245-2.8 19.8a.663.663 0 0 1 -.615.557l-1.822.085a.66.66 0 0 1 -.7-.677l.33-11.881a.22.22 0 0 0 -.435-.051l-3.183 12.533a.656.656 0 0 1 -.645.526z",
    fill: "#2f2e41",
    transform: "translate(-243.669 -499.341)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.167,
    cy: 35.245,
    fill: "#ffb8b8",
    rx: 3.466,
    ry: 3.466
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m265.475 440.865.381 8.222.138 2.991a.655.655 0 0 0 .434.589l8.938 3.238a.631.631 0 0 0 .226.04.655.655 0 0 0 .658-.676l-.366-14.784a5.211 5.211 0 0 0 -4.338-5.035c-.086-.013-.174-.026-.262-.038a5.115 5.115 0 0 0 -4.116 1.332 5.254 5.254 0 0 0 -1.691 4.12z",
    fill: "#ccc",
    transform: "translate(-253.078 -395.438)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m342.8 530.652a1.42 1.42 0 0 1 -.758-2.149l-3.031-4.03 2.615-.162 2.477 3.852a1.427 1.427 0 0 1 -1.3 2.489z",
    fill: "#ffb8b8",
    transform: "translate(-316.24 -471.825)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m319.942 465.621a.655.655 0 0 1 -.359-.355l-4.566-10.879a1.759 1.759 0 1 1 3.243-1.361l4.566 10.879a.66.66 0 0 1 -.353.863l-2.027.851a.655.655 0 0 1 -.5 0z",
    fill: "#ccc",
    transform: "translate(-295.516 -409.672)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m298.033 492.773 4.386-8.4a.688.688 0 0 1 .928-.291l6.366 3.325a.688.688 0 0 1 .291.928l-4.386 8.4a.688.688 0 0 1 -.928.291l-6.366-3.325a.688.688 0 0 1 -.291-.928z",
    fill: "#3f3d56",
    transform: "translate(-280.98 -437.207)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m280.4 498.146a1.42 1.42 0 0 0 -2.19-.629l-4.2-2.788-.007 2.62 3.997 2.245a1.427 1.427 0 0 0 2.407-1.449z",
    fill: "#ffb8b8",
    transform: "translate(-260.41 -446.417)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m250.749 455.2-3.434-2.72a2.422 2.422 0 0 1 -1.1-3.829l3.118-4.087a1.425 1.425 0 0 1 2.417 1.451l-2.467 4.036 3.626 1.72a.659.659 0 0 1 .275.948l-1.464 2.316a.661.661 0 0 1 -.447.3h-.011a.663.663 0 0 1 -.513-.135z",
    fill: "#ccc",
    transform: "translate(-236.068 -402.884)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m277.474 374.735a.3.3 0 0 1 .262-.4.7.7 0 0 1 .491.242 1.953 1.953 0 0 0 .433.372.373.373 0 0 0 .491-.089.683.683 0 0 0 -.026-.53 5.207 5.207 0 0 1 -.23-1.379 2.428 2.428 0 0 1 .347-1.474 1.951 1.951 0 0 1 1.672-.711 11.23 11.23 0 0 1 1.878.333.631.631 0 0 0 .614-.1.791.791 0 0 0 .032-.706 4.9 4.9 0 0 0 -.743-1.771 2.667 2.667 0 0 0 -1.7-.958 4.084 4.084 0 0 0 -1.9.216 5.094 5.094 0 0 0 -2.5 1.738 4.125 4.125 0 0 0 -.787 3.048 3.763 3.763 0 0 0 1.4 2.378z",
    fill: "#2f2e41",
    transform: "translate(-261.925 -337.169)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m568.047 673.748a6.49 6.49 0 0 1 -2.409-10.088 6.491 6.491 0 1 0 8.829 9.379 6.487 6.487 0 0 1 -6.42.709z",
    fill: "#3f3d56",
    transform: "translate(-508.601 -591.51)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportFaqIcon);
export default __webpack_public_path__ + "static/media/support_faq_icon.ad14aa26e5feeca86c6b2f97765abe35.svg";
export { ForwardRef as ReactComponent };